import operatorBuilder from './operator-suggestion'
import questionBuilder from './question-suggestion'
import clusterBuilder from './cluster-suggestion'
import sectionBuilder from './section-suggestion'
import traitBuilder from './trait-suggestion'
import variableBuilder from './variable-suggestion'
import codebookBuilder from './codebook-suggestion'
import tagBuilder from './tag-suggestion'

export default [
  operatorBuilder,
  questionBuilder,
  clusterBuilder,
  sectionBuilder,
  traitBuilder,
  variableBuilder,
  codebookBuilder,
  tagBuilder
]
